// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilos generales */

.quienes-somos {
    text-align: center;
    padding: 20px;
  }
  
  .miembros {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .miembro {
    margin: 50px;
    text-align: center;
  }
  
  .miembro img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    border: 2px solid #ccc;
  }
  
  .miembro h3 {
    margin-top: 10px;
    font-size: 16px;
  }
  
  /* Estilos adicionales */
  
  /* Puedes añadir aquí estilos adicionales para personalizar el componente, como: */
  
 
  
  /* Cambiar el color del título */
  .quienes-somos h2 {
    color: #333;
  }
  
  /* Añadir un borde al componente */
  .quienes-somos {
    border: 1px solid #ddd;
  }

  .miembro h3 a {
    color: #000;
    text-decoration: none;
  }
  
  .miembro h3 a:hover {
    text-decoration: underline;
  }
  
  @media (max-width: 480px) {
    .miembro {
      margin: 20px;
      text-align: center;
    }
  }
  @media (min-width: 480px) and (max-width: 767px) {

  .miembro {
    margin: 20px;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/about-us/about-us.component.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;IACI,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,wBAAwB;;EAExB,kFAAkF;;;;EAIlF,gCAAgC;EAChC;IACE,WAAW;EACb;;EAEA,kCAAkC;EAClC;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE;MACE,YAAY;MACZ,kBAAkB;IACpB;EACF;EACA;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF","sourcesContent":["/* Estilos generales */\r\n\r\n.quienes-somos {\r\n    text-align: center;\r\n    padding: 20px;\r\n  }\r\n  \r\n  .miembros {\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-wrap: wrap;\r\n  }\r\n  \r\n  .miembro {\r\n    margin: 50px;\r\n    text-align: center;\r\n  }\r\n  \r\n  .miembro img {\r\n    width: 100px;\r\n    height: 100px;\r\n    border-radius: 50%;\r\n    border: 2px solid #ccc;\r\n  }\r\n  \r\n  .miembro h3 {\r\n    margin-top: 10px;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  /* Estilos adicionales */\r\n  \r\n  /* Puedes añadir aquí estilos adicionales para personalizar el componente, como: */\r\n  \r\n \r\n  \r\n  /* Cambiar el color del título */\r\n  .quienes-somos h2 {\r\n    color: #333;\r\n  }\r\n  \r\n  /* Añadir un borde al componente */\r\n  .quienes-somos {\r\n    border: 1px solid #ddd;\r\n  }\r\n\r\n  .miembro h3 a {\r\n    color: #000;\r\n    text-decoration: none;\r\n  }\r\n  \r\n  .miembro h3 a:hover {\r\n    text-decoration: underline;\r\n  }\r\n  \r\n  @media (max-width: 480px) {\r\n    .miembro {\r\n      margin: 20px;\r\n      text-align: center;\r\n    }\r\n  }\r\n  @media (min-width: 480px) and (max-width: 767px) {\r\n\r\n  .miembro {\r\n    margin: 20px;\r\n    text-align: center;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
